import React from 'react';
import { IconChevronDown } from '@yoti/ui-kit-components-react/icons';

import './ChevronDownIcon.scss'

const ChevronDownIcon = () => (
  <div className="chevron-down">
    <span className="chevron-down__icon"><IconChevronDown /></span>
  </div>
)

export default ChevronDownIcon;
